/**
 * Vite entry point. Boots the Phaser game into #game.
 * See: game/Game.ts for the Phaser config, scenes/BootScene.ts for startup.
 */
import { startGame } from "./game/Game";
import { mountOverlay } from "./ui/overlay";
import { mountTrashboardPage } from "./ui/trashboardPage";
import "./ui/trashboard.css";

const pathname = window.location.pathname.toLowerCase().replace(/\/$/, "");
const isTrashboard =
  pathname === "/trashboard" ||
  pathname.endsWith("/trashboard") ||
  pathname.endsWith("/trashboard.html");

if (isTrashboard) {
  const app = document.getElementById("app");
  if (app) {
    mountTrashboardPage(app);
  }
} else {
  mountOverlay(document.getElementById("overlay-root"));
  startGame(document.getElementById("game"));
}

